import { useMemo } from 'react'
import { countryList } from '@velasca/constants'
import { formatCountries } from '@velasca/utils/format-countries'
import { $settings } from '@velasca/utils/globals'

interface FormattedCountry {
  code: string
  label: string
}

export const useCountry = (): FormattedCountry | undefined => {
  return useMemo(() => {
    const langCode = $settings.language
    const countryCode = $settings.country

    if (!countryCode) {
      return undefined
    }

    const countries = formatCountries(countryList, langCode)

    return countries.find(({ code }) => code === countryCode)
  }, [])
}
